import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-switcher',
  template: `
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
      <h3 class="col-span-full text-sm font-semibold text-base-content/60 mt-2">Light</h3>
      <button (click)="changeTheme('light')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'light'">Light</button>
      <button (click)="changeTheme('corporate')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'corporate'">Corporate</button>
      <button (click)="changeTheme('cupcake')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'cupcake'">Cupcake</button>
      <button (click)="changeTheme('bumblebee')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'bumblebee'">Bumblebee</button>
      <button (click)="changeTheme('emerald')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'emerald'">Emerald</button>
      <button (click)="changeTheme('fantasy')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'fantasy'">Fantasy</button>
      <button (click)="changeTheme('garden')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'garden'">Garden</button>
      <button (click)="changeTheme('pastel')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'pastel'">Pastel</button>
      <button (click)="changeTheme('autumn')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'autumn'">Autumn</button>
      <button (click)="changeTheme('lemonade')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'lemonade'">Lemonade</button>
      <button (click)="changeTheme('winter')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'winter'">Winter</button>

      <h3 class="col-span-full text-sm font-semibold text-base-content/60 mt-2">Dark</h3>
      <button (click)="changeTheme('dark')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'dark'">Dark</button>
      <button (click)="changeTheme('business')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'business'">Business</button>
      <button (click)="changeTheme('night')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'night'">Night</button>
      <button (click)="changeTheme('coffee')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'coffee'">Coffee</button>
      <button (click)="changeTheme('dim')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'dim'">Dim</button>
      <button (click)="changeTheme('nord')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'nord'">Nord</button>
      <button (click)="changeTheme('dracula')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'dracula'">Dracula</button>
      <button (click)="changeTheme('black')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'black'">Black</button>
      <button (click)="changeTheme('luxury')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'luxury'">Luxury</button>
      <button (click)="changeTheme('forest')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'forest'">Forest</button>
      <button (click)="changeTheme('abyss')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'abyss'">Abyss</button>

      <h3 class="col-span-full text-sm font-semibold text-base-content/60 mt-2">Vibrant</h3>
      <button (click)="changeTheme('synthwave')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'synthwave'">Synthwave</button>
      <button (click)="changeTheme('cyberpunk')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'cyberpunk'">Cyberpunk</button>
      <button (click)="changeTheme('valentine')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'valentine'">Valentine</button>
      <button (click)="changeTheme('halloween')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'halloween'">Halloween</button>
      <button (click)="changeTheme('sunset')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'sunset'">Sunset</button>
      <button (click)="changeTheme('retro')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'retro'">Retro</button>
      <button (click)="changeTheme('aqua')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'aqua'">Aqua</button>
      <button (click)="changeTheme('lofi')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'lofi'">Lo-Fi</button>
      <button (click)="changeTheme('caramellatte')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'caramellatte'">Caramel Latte</button>
      <button (click)="changeTheme('silk')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'silk'">Silk</button>

      <h3 class="col-span-full text-sm font-semibold text-base-content/60 mt-2">Specialty</h3>
      <button (click)="changeTheme('wireframe')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'wireframe'">Wireframe</button>
      <button (click)="changeTheme('cmyk')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'cmyk'">CMYK</button>
      <button (click)="changeTheme('acid')" class="btn btn-sm" [class.btn-primary]="currentTheme === 'acid'">Acid</button>
    </div>
  `,
  standalone: true
})
export class ThemeSwitcherComponent implements OnInit {
  currentTheme = 'dark';

  changeTheme(theme: string) {
    this.currentTheme = theme;
    document.documentElement.setAttribute('data-theme', theme);
    
    // Store in localStorage for persistence
    localStorage.setItem('coursebuilder-theme', theme);
  }

  ngOnInit() {
    // Priority: localStorage (user preference) > HTML attribute > default 'dark'
    // Note: The theme is already applied by inline script in index.html,
    // this just syncs the component's currentTheme state
    const savedTheme = localStorage.getItem('coursebuilder-theme');
    const htmlTheme = document.documentElement.getAttribute('data-theme');

    this.currentTheme = savedTheme || htmlTheme || 'dark';

    // Ensure the DOM is in sync (should already be set by inline script)
    document.documentElement.setAttribute('data-theme', this.currentTheme);

    // If we read from htmlTheme (not localStorage), persist it
    if (!savedTheme && htmlTheme) {
      localStorage.setItem('coursebuilder-theme', htmlTheme);
    }
  }
}
